module.exports = "/dist/montserrat-latin-700italic.svg?321eced1ed63a24e07157ef8d0be72a7";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700italic.svg
// module id = 79
// module chunks = 0